import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import HandymanIcon from "@mui/icons-material/Handyman";
import useAppNavigate from "hooks/useAppNavigate";
import { ROUTE } from "components/base-app/AppRoutes";

const ProfileMyTools = () => {
  const navigateTo = useAppNavigate();

  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={0.5}>
        <HandymanIcon sx={{ color: "#f79c6c" }} />
        <Typography variant="h6" fontWeight={600} sx={{ color: "#1A2222" }}>
          My Tools
        </Typography>
      </Box>
      <Typography variant="body2" sx={{ color: "rgba(26, 34, 34, 0.72)", mb: 2 }}>
        Tools to help you measure impact and take action.
      </Typography>

      <Stack spacing={2}>
        <Card
          sx={{
            borderRadius: 4,
            backgroundColor: "#FFFFFF",
            color: "#1A2222",
            border: "1px solid rgba(247, 156, 108, 0.35)",
            boxShadow: "0 2px 12px rgba(0, 0, 0, 0.06)",
          }}
        >
          <CardContent sx={{ p: 3 }}>
            <Box display="flex" alignItems="center" gap={1} mb={1.5}>
              <AutoAwesomeIcon sx={{ color: "#f79c6c" }} />
              <Typography variant="subtitle1" fontWeight={600} sx={{ color: "#f79c6c" }}>
                ESG Impact Report Converter
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: "rgba(26, 34, 34, 0.72)", mb: 2.5 }}>
              Upload your company's ESG sustainability report to automatically extract CO₂ emissions and convert them into tree compensation targets.
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => navigateTo(ROUTE.ESG_CONVERTER)}
              sx={{
                borderRadius: 2.5,
                fontWeight: 600,
                py: 1,
                backgroundColor: "#f79c6c",
                color: "#1A2222",
                "&:hover": {
                  backgroundColor: "#ffcd9b",
                },
              }}
            >
              Convert ESG Report
            </Button>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
};

export default ProfileMyTools;
